import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TemplateMessage} from "./types";

export type FetchTemplateMessageVariables = {code: string};

const fetchTemplateMessage = async (variables: FetchTemplateMessageVariables): Promise<TemplateMessage> => {
  const response = await axiosReachInstance.get<TemplateMessage, AxiosResponse<TemplateMessage>>(
    "/templates/message",
    {params: {code: variables.code}}
  );
  return response.data;
};

export const useFetchTemplateMessage = (
  options?: BaseMutationOptions<TemplateMessage, FetchTemplateMessageVariables>
): BaseUseMutationResult<TemplateMessage, FetchTemplateMessageVariables> =>
  useBaseMutation<TemplateMessage, FetchTemplateMessageVariables>(fetchTemplateMessage, options);
